// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tab"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M6.5 15L6.5 5L2.5 5L2.5 15H6.5Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M14 15L14 5L10 5V15L14 15Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M21.5 15V5L17.5 5L17.5 15H21.5Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M6.5 15L6.5 5L2.5 5L2.5 15H6.5Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M14 15L14 5L10 5V15L14 15Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M21.5 15V5L17.5 5L17.5 15H21.5Z","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2.5 19L21.5 19","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TabIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tab',
    ref,
    icon: element,
  },
));

TabIcon.displayName = 'TabIcon';

export default TabIcon;
